import React from 'react';
import { Link } from 'react-router-dom';
import door1 from '../../assets/Door1.webp';
import door2 from '../../assets/Door2.webp';
import door3 from '../../assets/door3.webp';
import door4 from '../../assets/Door4.jpeg';
import door5 from '../../assets/Door5.jpeg';

const Door = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="w-full h-[400px] md:h-[300px] flex flex-col justify-center px-6 hero-bg-color">
        <h1 className="text-white text-4xl md:text-5xl font-bold">Doors</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Doors
        </div>
      </div>

      <div className="max-w-7xl mx-auto py-10 px-6">
        <hr className="border-gray-300/30 mb-10" />
        <div className="grid gap-6 md:grid-cols-3">
          {[
            { src: door1, alt: 'Door 1' },
            { src: door2, alt: 'Door 2' },
            { src: door3, alt: 'Door 3' },
            { src: door4, alt: 'Door 4' },
            { src: door5, alt: 'Door 5' },
          ].map((image, index) => (
            <div key={index} className="overflow-hidden rounded-3xl shadow-lg bg-white h-[440px]">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Door;
